const messages = {
    en: {
        passwordreset: "Reset password",
    },
    ru: {
        passwordreset: "Сброс пароля",
    }
  };

  export default messages;